import customerFullcont from "./customer-fullcont.html";

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const handler = require('./customer-fullcont-handler')
const extrainfo = require('./customer-fullcont-extrainfo')
const customerDt = require('./customer-dt')
const customerMenu = require('./customer-menu')
const { formCopy } = require('./customer-fullcont-form')
const { form } = require('./customer-fullcont-form')
const customerMT = undefined //no MT just add this like undefined
const customerJump = require('./customer-jump')
const dtHandler = require('../../../../../components/dt/dt-handler')

const { generateImage } = require('../../../../../components/avatar/avatar-generator')

/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false

function HTMLselect(detail) {

      fullcontHandler.HTMLselect(

            'customer', //database table name****
            'customer', //dest entity on js
            'customer-fullcont',
            customerFullcont, form, formCopy, customerMT,
            editDialog, deleteDialog, dtCall, htmlFc)

      HTMLwasSelected = true
      handler.initDataFc(htmlFc)
      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail) {  //console.log('customer-dt 5>', detail)

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/


const obj = {

      addOne:                            { start: (detail) => { addOne(detail, htmlFc) } },
      cancelEdit:                        { start: (detail) => { fullcontEntity.cancelEdit(detail, htmlFc) } },
      deleteEntity:                      { start: (detail) => { fullcontEntity.deleteEntity(detail, htmlFc) } },
      deleteFromDialog:                  { start: (detail) => { deleteFromDialog(detail, htmlFc) } },
      discard:                           { start: (detail) => { fullcontHandler.discard(detail, htmlFc) } },
      fullcontOptions:                   { start: (detail) => { customerMenu.start(detail, 'htmlDt', htmlFc) } },
      hide:                              { start: (detail) => { fullcontEntity.hide(detail, htmlFc), extrainfo.clean(htmlFc) } },
      prepareAdd:                        { start: (detail) => { prepareAdd(detail) } },
      prepareEdit:                       { start: (detail) => { prepareEdit(detail, htmlFc) } },
      saveFromDialog:                    { start: (detail) => { saveFromDialog(detail, htmlFc) } },
      selectOne:                         { start: (detail) => { fullcontEntity.selectOne(detail, htmlFc, processSelectOne)} },
      selectOneNoCheck:                  { start: (detail) => { fullcontEntity.selectOneNoCheck(detail, htmlFc, processSelectOne) } },
      update:                            { start: (detail) => { fullcontEntity.update(detail, htmlFc) } },
      addBillingToShipping:              { start: (detail) => { handler.addBillingToShipping(detail, htmlFc) } },
      jump:                              { start: (detail) => { customerJump.start(detail, htmlFc) } },
      checkEmailInput:                   { start: (detail) => { handler.checkEmailInput(htmlFc) } },
      sendEmailFromButton:               { start: (detail) => { handler.sendEmailFromButton(htmlFc) } },
      printBehaivor:                     { start: (detail) => { extrainfo.printBehaivor(detail, htmlFc) } },

}/**/

function prepareAdd(detail) {
      extrainfo.clean(htmlFc)
      fullcontEntity.prepareAdd(detail, htmlFc)
      handler.hideButtonResetPassword(htmlFc)
}

export function resetFullcont(detail, htmlFc) {
      fullcontEntity.selectOne(detail, htmlFc)
}

async function saveFromDialog(detail, htmlFc) {
      let add = htmlFc.fullcontHTML.classList.contains('mode-add');

      if (add) { //email input
            if (await handler.checkEmailInput(htmlFc, true)) {
                  fullcontEntity.saveFromDialog(detail, htmlFc, processEmail);
            }
      } else {
            fullcontEntity.saveFromDialog(detail, htmlFc, function () {
                  handler.showButtonResetPassword(htmlFc);
            });
      }
}

//function to send
function editDialog() {
      dialog.start({ act: "show", id: "saveChanges", entity: 'customer' })
}

function deleteDialog(detail) {
      dialog.start({ act: "show", dest: 'customer', id: "deleteElem", entity: 'customer', dbid: detail.dbid })
}

function dtCall(act, result) {
      customerDt.start({ act: act, row: result })
}

function prepareEdit(detail, htmlFc) {

      const div = htmlFc.fullcontHTML.querySelector('#customer_form_email')
      const emailInput = div.querySelector('.elem');
      const estaVacio = emailInput.value !== "";

      div.classList.toggle("disable-mode-edit", estaVacio);

      fullcontHandler.prepareEdit(detail, htmlFc)
}

async function addOne(detail, htmlFc) {

      if (await handler.checkEmailInput(htmlFc, true)) {
            fullcontEntity.addOne(detail, htmlFc, processEmail);

            generateImage(detail, htmlFc)
      }
}

function processEmail(data, result) {
      data.new_user = true;
      handler.sendResetEmail(data, htmlFc);
      handler.showButtonResetPassword(htmlFc);

}

function deleteFromDialog(detail, htmlFc) {

      fullcontEntity.deleteFromDialog(detail, htmlFc)
      setTimeout(() => {
            customerDt.start({ "dest": "customer", "elem": "dt", "act": "select", "entity": "customer" })
      }, 900)

}

function processSelectOne(data, result) {
      extrainfo.fill(result.extrainfo, htmlFc)
      handler.showButtonResetPassword(htmlFc);
      handler.initChatsFc(data.chats)
}
